import React, { useContext, useState, useEffect } from 'react';

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import FilterCtx from '../../../../context/filterContext/filterCtx';

import '../../dropdown/dropdown.scss';
import '../filters.scss';

const readStates = [
  { text: 'Read and Unread', value: 'all' },
  { text: 'Read', value: 'read' },
  { text: 'Unread', value: 'unread' },
];

const ReadFilter: React.FC = () => {
  const [value, setValue] = useState<string>('all');

  const filterCtx: any = useContext(FilterCtx);

  const handleReadChange = (event: DropDownListChangeEvent): void => {
    setValue(event.value && event.value.value);
  };

  useEffect(() => {
    if (filterCtx.read) {
      setValue(filterCtx.read);
    }
  }, []);

  useEffect(() => {
    filterCtx.setRead(value);
  }, [value]);

  return (
    <div className='read-filter-wrapper pointer'>
      <DropDownList
        data={readStates}
        className='custom-dropdown-style filters-dropdown'
        defaultValue={value === 'all' ? readStates[0] : value === 'read' ? readStates[1] : readStates[2]}
        textField='text'
        dataItemKey='value'
        onChange={handleReadChange}
      />
    </div>
  );
};

export default ReadFilter;
